import logo from "assets/icons/dashboard-logo.svg";
import AccordionItem from "./Accordion";
import { useRef, useState } from "react";
import html2canvas from "html2canvas";
import rateStar from "assets/icons/rate-star.svg";
import download from "assets/icons/download.svg";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import moment from "moment";
import LoaderDiv from "./LoaderDiv";

const Prescription = ({
  consultation,
  doctor,
  diagnosis,
  feedbackButton,
  t,
}) => {
  const pageRef = useRef(null);
  const [accordionIsOpen, setAccordionIsOpen] = useState(true);
  const [downloading, setDownloading] = useState(false);

  // Function to handle downloading the page
  const handleDownload = async () => {
    if (pageRef.current) {
      setDownloading(true);
      try {
        // Convert the page to canvas
        const canvas = await html2canvas(pageRef.current, {
          scale: 2, // Increase the scale for better quality
          useCORS: true, // Enable cross-origin image loading
          allowTaint: true,
        });

        const image = canvas.toDataURL("image/png");
        const link = document.createElement("a");
        link.href = image;
        link.download = "prescription.png";
        link.click();
        setDownloading(false);
      } catch (error) {
        console.error("Error downloading page:", error);
        setDownloading(false);
      }
    }
  };

  return (
    <AccordionItem
      className="assessment-accordion"
      title={
        <div className="assessment-title-wrapper">
          <span className="your-assessment">
            {t("summary.your_assessment")}
          </span>
          <div className="rate-consultation-wrapper">
            <button
              onClick={() => feedbackButton()}
              className="rate-consultation"
            >
              <img src={rateStar} alt="rate" />
              <span className="rate-consultation-text">
                {t("summary.rate_consultation")}
              </span>
              <span className="rate-consultation-text-mobile">Rate</span>
            </button>

            {!downloading ? (
              <div
                onClick={() => handleDownload()}
                className="download-assessment-wrapper"
              >
                <img src={download} alt="download" className="download-img" />
                <span className="download-assessment-text">
                  {t("summary.download_assessment")}
                </span>
              </div>
            ) : (
              <div className="download-assessment-wrapper">
                <LoaderDiv />
              </div>
            )}
          </div>
        </div>
      }
      isOpen={accordionIsOpen}
      imgClick={() => setAccordionIsOpen(!accordionIsOpen)}
    >
      <div className="prescription-gap" ref={pageRef}>
        <div className="prescription-container">
          <div className="prescription-header">
            <img src={logo} alt="logo" className="prescription-logo" />
            <div className="contact-info-container">
              <div className="contact-info-item">
                <span className="info-label">{t("summary.address")} :</span>
                <span className="info-value">Sørkedalsveien 8, 0369 Oslo</span>
              </div>
              <div className="contact-info-item">
                <span className="info-label">{t("summary.email")} :</span>
                <span className="info-value">hei@drdropin.no</span>
              </div>
              <div className="contact-info-item contact-info-last">
                <span className="info-label">
                  {t("summary.organization_number")} :
                </span>
                <span className="info-value">919 149 795</span>
              </div>
            </div>
          </div>
          <div className="prescription-content">
            <span className="prescription-text">
              <div
                dangerouslySetInnerHTML={{ __html: diagnosis[0].description }}
              />
            </span>
            <span className="signoff-message">
              {doctor.signoff_message ?? ""}
            </span>

            {diagnosis[0].next_appointment && (
              <span className="next-app-container">
                {t("summary.doctor_recommends_another_appointment")}{" "}
                <span className="next-app-date">
                  {moment(diagnosis[0].next_appointment).format("DD-MM-yyyy")}
                </span>{" "}
                {diagnosis[0].next_appointment_type !== null && (
                  <span> via {diagnosis[0].next_appointment_type} </span>
                )}
                {t("summary.consultation")}
              </span>
            )}

            <div className="signature-container">
              <img
                src={doctor.signatureUrl}
                alt="signature"
                className="signature-image"
              />

              <div className="doctor-profile">
                <img
                  src={doctor.profileUrl}
                  alt="profile"
                  className="doctor-photo"
                />
                <div className="doctor-info">
                  <span className="doctor-name">Dr. {doctor.display_name}</span>
                  <span className="doctor-credentials">
                    {doctor.qualifications}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AccordionItem>
  );
};
function mapStateToProps(state) {
  return {};
}

export default connect(mapStateToProps, {})(withTranslation()(Prescription));
